import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PdpRelatedItem from './pdpRelatedItem';
var PdpRelated = function (_a) {
    var _b;
    var data = _a.data, addToShopifyCart = _a.addToShopifyCart;
    var plantListMore = null;
    var content = null;
    var genusName = data.genus.name ? data.genus.name : data.genus;
    var sortedPlants = ((_b = data === null || data === void 0 ? void 0 : data.plant_list) === null || _b === void 0 ? void 0 : _b.length) > 0 && data.plant_list.sort(function (a, b) { return (a.is_for_sale === b.is_for_sale ? 0 : a.is_for_sale ? -1 : 1); });
    if (!isEmpty(data)) {
        plantListMore = ((sortedPlants === null || sortedPlants === void 0 ? void 0 : sortedPlants.length) < data.plant_count) && (React.createElement("div", { className: "pdp_related_more" },
            React.createElement("a", { href: "".concat(data.genus.url), className: "btn primary" },
                React.createElement("p", null, "+".concat(data.plant_count - sortedPlants.length, " more ").concat(genusName)))));
    }
    if ((sortedPlants === null || sortedPlants === void 0 ? void 0 : sortedPlants.length) > 0) {
        content = (React.createElement("div", { className: "pdp_related" },
            React.createElement("h2", null, "See other plant types of ".concat(genusName, " for your garden")),
            React.createElement("div", { className: "pdp_related__results" }, sortedPlants === null || sortedPlants === void 0 ? void 0 :
                sortedPlants.map(function (item) { return (React.createElement(PdpRelatedItem, { data: item, key: item.django_pk, onAddToShopifyCart: addToShopifyCart })); }),
                plantListMore)));
    }
    return content;
};
export default PdpRelated;
